import React, { FC, memo, useCallback, useState, ChangeEvent } from 'react';
import { Container, Select, Button } from './styles';
import { Props } from './types';

const AppliesTo: FC<Props> = ({ options, onAdd, disabled, ...props }) => {
  const [selectedItem, setSelectedItem] = useState<string>('');

  const handleChangeSelect = useCallback(
    (event: ChangeEvent<{ label?: string; value: unknown }>) => {
      setSelectedItem(event.target.value as string);
    },
    [setSelectedItem],
  );

  const handleOnClick = useCallback(() => {
    onAdd(selectedItem);
    setSelectedItem('');
  }, [onAdd, selectedItem, setSelectedItem]);

  const noOptions = options.length === 0;
  return (
    <Container {...props}>
      <Select
        options={options}
        value={selectedItem}
        handleChange={handleChangeSelect}
        placeholder="Select item"
        disabled={noOptions}
      />
      <Button
        type="button"
        onClick={handleOnClick}
        disabled={selectedItem === '' || noOptions || disabled}
      >
        Add
      </Button>
    </Container>
  );
};

export default memo(AppliesTo);

// TODO: TFR-29 add story to component
